/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit} from '@angular/core';
import {NgModule} from '@angular/core';
import {DataTableModule,ButtonModule,PaginatorModule,DropdownModule, PanelModule} from "primeng/primeng";
import {FormsModule, FormGroup, ReactiveFormsModule, FormBuilder, FormControl, Validators} from "@angular/forms";

import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";
import { MamAdminService } from '../../service/mam_service.component';
import { MamVisitorService } from '../../service/mam_visitor_service.component';
import {CommonModule} from "@angular/common";
import {SearchModule} from "../../component/search.component";
import {SelectItem} from "primeng/components/common/api";
import { ExDialogModule } from  '../../component/dialog.component';

import { ReservedVisitor } from '../../model/reserved_visitor';
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS

@Component({

selector: 'visitor-management',
templateUrl: 'visitor_management.html'
})
export class VisitorManagementComponent implements  OnInit{

  private reserved_list : ReservedVisitor[] = [];

  totalRecord: number;
  searchIDs: SelectItem[];
  table_list: any;

  dateIsTrue : boolean;

  searchIsTrue : boolean;
  sDate: string;
  eDate: string;

  searchText: string;
  searchId : string;
  pageMax:number =10;

  // popup
  addShow : boolean = false;
  delShow : boolean = false;

  addForm : FormGroup;

  dialogWidth: number = 600;



  constructor(private service:MamAdminService, private visitor_service : MamVisitorService, private fb : FormBuilder, private logger : Logger) {
    // this.searchIDs = [];
    // this.searchIDs.push({label: '---------------', value: 'all'});
    // this.searchIDs.push({label: '인증서 별칭', value: 'name'});
    // this.searchIDs.push({label: '유효기간 종료일', value: 'notAfterDate'});

    this.addForm = this.fb.group({
      'name' : new FormControl('',Validators.required),
      'phoneNumber' : new FormControl('',Validators.required),
      'employeeName' : new FormControl('',Validators.required),
      'employeeDept' : new FormControl('', Validators.required)
      // 'endDate' : new FormControl('', Validators.required)
    });

    this.dateIsTrue = false;
  }

  ngOnInit(): void {
    this.getReservedVisitor(1,10,'','','all');
  }
  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.searchId = event.searchId;

   // this.getCertList(1,this.pageMax,'2016-09-12', '2017-02-13',this.searchText, "true", this.searchId);

  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {

     // this.getCertList(event.page + 1, event.rows,'2016-09-12', '2017-02-13',this.searchText, "true", this.searchId);
    } else {

     // this.getCertList(event.page + 1, event.rows,'2016-09-12', '2017-02-13',"", '',"");
    }

  }

  ///////////////////////////////////// service
  getReservedVisitor(page:number, max:number, search:string, like:string, field:string) {
    this.visitor_service.getReservedVisitor(page, max, search, like, field).subscribe(
        value => {
          this.reserved_list = value.rows;
          this.logger.debug("visitor_list : ", value);
        },
        error => { this.logger.error("-- error : " + error); },
        () =>    { this.logger.info("-- complate : "); })
  }

  insertReservedVisitor(ReservedVisitor :any, flag:number) {
    this.visitor_service.insertReservedVisitor(ReservedVisitor, flag).subscribe(
        value => {
          let reuslt = value;
          this.logger.debug("insertReservedVisitor result : ", value);
        },
        error => { this.logger.error("-- error : " + error); },
        () =>    { this.logger.info("-- complate : "); }
    )
  }

  deleteReservedVisitor(id:number) {
    this.visitor_service.deleteReservedVisitor(id).subscribe(
        value => {
          let reuslt = value;
          this.logger.debug("deleteReservedVisitor result : ", value);
        },
        error => { this.logger.error("-- error : " + error); },
        () =>    { this.logger.info("-- complate : "); }
    )
  }

  multiDel(ids:string) {
    this.visitor_service.multiDel(ids).subscribe(
        value => {
          let reuslt = value;
          this.logger.debug("multiDel result : ", value);
        },
        error => { this.logger.error("-- error : " + error); },
        () =>    { this.logger.info("-- complate : "); }
    )
  }




  ///////////////////////////////////// service
  ///////////////////////////////////// event
  addReservedsVisitor(event) {
    this.addShow = true;
    this.logger.debug("==== add");
  }
  delReservedsVisitor(event) {
    this.delShow = true;
    this.logger.debug("==== del");
  }

  onSubmit(data) {
    this.logger.debug("form data :", data);
    // let datePipe = new DatePipe("en");
    // let sDate = datePipe.transform(event.startDate, 'yyyy-MM-dd');
    // let eDate = datePipe.transform(event.endDate, 'yyyy-MM-dd');
    // let reserved_visitor = {id : null, name : data.name, employeeName : data.employeeName, phoneNumber : data.phoneNumber,
    //   endDate:eDate, company:this.selectedCompany};
    // this.insertNotice(notice);
    // this.addShow = false;
    // this.addForm.reset();

  }
  ///////////////////////////////////// service







}
@NgModule({
  imports: [DataTableModule,ButtonModule,HttpModule,BrowserModule, CommonModule,PaginatorModule,DropdownModule,FormsModule,SearchModule, ReactiveFormsModule, ExDialogModule, PanelModule],
  exports: [VisitorManagementComponent],
  declarations: [VisitorManagementComponent],
  providers: [MamAdminService],
})
export class VisitorManagementModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/visitor/visitor_management.ts